import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import { ContentProps } from "./Content.types";

export const Content: React.FC<ContentProps> = ({
  template,
}) => {
  const safeHTML = DOMPurify.sanitize(template ?? "", { ADD_ATTR: ['target'] });


  useEffect(() => {
    const handleChatClick = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.closest('.btn-chat')) {
        window.SI_API?.showPopup();
      }
    };

    document.addEventListener('click', handleChatClick);
    return () => {
      document.removeEventListener('click', handleChatClick);
    };
  }, [template, safeHTML]);

  return (
    <div className='w-100' dangerouslySetInnerHTML={{ __html: safeHTML }} />
  );
}